<template>
    <div class="attached-item" v-if="attachmentsComputed.length > 1">
        <div class="attached-item__title">
            <h3 class="text-normal font-medium mb-2.5">{{ groupName }}</h3>
        </div>
        <div class="attachment-card-group">
            <Component
                v-for="attachment in attachmentsComputed"
                :key="attachment.id"
                :is="cardType(attachment)"
                :item="attachment"
                :attachment-type="attachmentType"
                in-group
                :parent-added="parentAdded"
            />
        </div>
    </div>
</template>

<script>
import FlatFee from '@/BuyNow/Components/AttachmentTypes/FlatFee.vue';
import PerUnit from '@/BuyNow/Components/AttachmentTypes/PerUnit.vue';
import Stairstep from '@/BuyNow/Components/AttachmentTypes/Stairstep.vue';

export default {
    data() {
        return {
        };
    },
    components: {
        FlatFee,
        PerUnit,
        Stairstep,
    },
    mounted() {
    },
    props: {
        attachments: Object,
        attachmentType: String
    },
    methods: {
        selectedPricing(attachment) {
            let found;
            if (attachment.pricing.length > 1) {
                found = attachment.pricing.find((price) => {
                    return price.billingPeriodUnit === this.$store.getters.cartInfo.billingPeriod;
                });
            } else {
                found = attachment.pricing[0];
            }
            return found;
        },
        cardType(attachment) {
            switch(this.selectedPricing(attachment).model) {
                case 'per_unit':
                    return 'PerUnit';
                case 'stairstep':
                    return 'Stairstep';
                case 'flat_fee':
                    return 'FlatFee';
            }
        },
    },
    computed: {
        parentAdded() {
            if (this.attachmentsComputed.find(attachment => {
                return attachment.metadata.group.parent && attachment.type === 'mandatory'
            })) {
                return true;
            }
            return !!this.lineItems.find(item => item.itemId == this.attachmentsComputed.find(attachment => attachment.metadata.group.parent).itemId);
        },
        lineItems() {
            return [
                ...this.$store.state.cartInfo.selectedAddons,
                ...this.$store.state.cartInfo.selectedCharges,
            ];
        },
        attachmentsComputed() {
            return this.attachments.sort((a, b) => {
                return a.metadata.order - b.metadata.order;
            });
        },
        groupParent() {
            return this.attachmentsComputed.find(item => {
                return item.metadata.group.parent;
            })
        },
        groupName() {
            return this.groupParent.metadata?.title || this.groupParent.name;
        }
    },
    watch: {
    }
};
</script>

<style lang="postcss" scoped>
.attachment-card-group {
    @apply md:border-gray-4 md:border-2 md:rounded-medium gap-4.5 md:gap-0 flex flex-col;
}
</style>
